import { IWorkspacePlan } from 'src/constants/plan-service';

/**
 * 포스트 메모의 **플랜 게이트** — 체험(trial) 플랜은 메모를 남길 수 없다.
 *
 * 클라(`PostMemoProvider` · 메모 셀)와 서버(`server/fs/post-memo`)가 같은 규칙을 본다 — 화면은 업그레이드
 * 팝오버로 안내하고, 서버는 우회 호출을 같은 문구로 거절한다.
 */

/** 서버가 거절할 때의 문구 — 화면 토스트 계약 */
export const POST_MEMO_PLAN_BLOCKED_MESSAGE = '체험 플랜에서는 포스트 메모를 사용할 수 없어요. 플랜을 업그레이드해 주세요.';

/** 업그레이드 팝오버의 설명 — 다른 플랜 게이트(게시물 분석 등)와 같은 어조 */
export const POST_MEMO_UPGRADE_DESCRIPTION = '포스트 메모는 체험 플랜에서 사용할 수 없어요. 플랜을 업그레이드하면 팀 메모를 남길 수 있어요.';

/** 이 플랜에서 메모가 막히는가 — 판정은 planId 하나(체험 플랜) */
export function isPostMemoBlockedByPlan(planId: string | null | undefined): boolean {
  return String(planId ?? '').trim() === IWorkspacePlan.planId.plan_trial;
}
